import { render, staticRenderFns } from "./EmailText.vue?vue&type=template&id=4317b418&scoped=true&lang=pug&"
import script from "./EmailText.vue?vue&type=script&lang=coffee&"
export * from "./EmailText.vue?vue&type=script&lang=coffee&"
import style0 from "./EmailText.vue?vue&type=style&index=0&id=4317b418&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4317b418",
  null
  
)

export default component.exports